// extracted by mini-css-extract-plugin
export var checkboxContainer = "d_r";
export var checkboxError = "d_t";
export var checkboxField = "d_v";
export var checkboxFieldInput = "d_w";
export var checkboxFieldSpan = "d_x";
export var checkboxLabel = "d_s";